import { ButtonSubmit } from "../ButtonSubmit";
// import { VideoMobile } from "../VideoMobile";
import "./QuestionThree.scss";

export const QuestionThree = ({ nextStep }) => {
  const handleSubmit = () => {
    nextStep();
  };
  return (
    <div className="global__wrapper">
      {/* <VideoMobile /> */}
      <div className="form__global mobile">
        <h3 className="title__global small">What are you looking for here?</h3>
        <div className="looking__wrapper">
          <label className="container-looking">
            A friend
            <input className="looking" type="checkbox" name="looking" />
            <span className="checkmark-looking"></span>
          </label>
          <label className="container-looking">
            Light flirt
            <input className="looking" type="checkbox" name="looking" />
            <span className="checkmark-looking"></span>
          </label>
          <label className="container-looking">
            Life partner
            <input className="looking" type="checkbox" name="looking" />
            <span className="checkmark-looking"></span>
          </label>
          <label className="container-looking">
            Don’t know
            <input className="looking" type="checkbox" name="looking" />
            <span className="checkmark-looking"></span>
          </label>
        </div>
        <ButtonSubmit
          onClick={handleSubmit}
          className={"button"}
          text={"Continue"}
        />
      </div>
    </div>
  );
};
